import React, { Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Site from "./components/Site";
import ScrollToTop from "./components/ScrollToTop";

// Lazy load all page components
const Home = React.lazy(() => import("./components/home/Home"));
const Login = React.lazy(() => import("./components/login-register/Login"));
const MyAccount = React.lazy(() => import("./components/my-account/MyAccount"));
const TShirts = React.lazy(() => import("./components/products/TShirts"));
const ProductDetails = React.lazy(() => import("./components/product-details/ProductDetails"));
const ContactUs = React.lazy(() => import("./components/contact-us/ContactUs"));
const Cart = React.lazy(() => import("./components/cart/Cart"));
const Dashboard = React.lazy(() => import("./components/my-account/pages/Dashboard"));
const Orders = React.lazy(() => import("./components/my-account/pages/Orders"));
const OrderDetails = React.lazy(() => import("./components/my-account/pages/OrderDetails"));
const Profile = React.lazy(() => import("./components/my-account/pages/Profile"));
const ChangePassword = React.lazy(() => import("./components/my-account/pages/ChangePassword"));
const Addresses = React.lazy(() => import("./components/my-account/pages/Addresses"));
const Checkout = React.lazy(() => import("./components/checkout/Checkout"));
const OrderSuccess = React.lazy(() => import("./components/checkout/OrderSuccess"));
const Search = React.lazy(() => import("./components/products/Search"));
const TrackOrder = React.lazy(() => import("./components/track-order/TrackOrder"));
const TrackOrderDetails = React.lazy(() => import("./components/track-order/TrackOrderDetails"));
const AboutUs = React.lazy(() => import("./components/contact-us/AboutUs"));
const ReturnPolicy = React.lazy(() => import("./components/contact-us/ReturnPolicy"));
const TermsAndConditions = React.lazy(() => import("./components/contact-us/TermsAndConditions"));
const PrivacyPolicy = React.lazy(() => import("./components/contact-us/PrivacyPolicy"));
const ShippingPolicy = React.lazy(() => import("./components/contact-us/ShippingPolicy"));
const Sustainability = React.lazy(() => import("./components/contact-us/Sustainability"));
const MensPage = React.lazy(() => import("./components/products/MensPage"));
const WomensPage = React.lazy(() => import("./components/products/WomensPage"));
const CollectionsPage = React.lazy(() => import("./components/collections/CollectionsPage"));

const SuspenseLoader = () => (
  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' }}>
    <div className="spinner-border text-success" role="status">
      <span className="visually-hidden">Loading...</span>
    </div>
  </div>
);

export default function Router() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Suspense fallback={<SuspenseLoader />}>
        <Routes>
          <Route path={`/`} element={<Site />}>
            <Route path={`/`} element={<Home />} />
            <Route path={`/login`} element={<Login />} />
            <Route path={`/register`} element={<Login />} />
            <Route path={`/products`} element={<TShirts />} />
            <Route path={`/product-details`} element={<ProductDetails />} />
            <Route path={`/product-details/:id`} element={<ProductDetails />} />
            <Route path={`/contact-us`} element={<ContactUs />} />
            <Route path={`/cart`} element={<Cart />} />
            <Route path={`/checkout`} element={<Checkout />} />
            <Route path={`/order-success`} element={<OrderSuccess />} />
            <Route path={`/search`} element={<Search />} />
            <Route path={`/mens`} element={<MensPage />} />
            <Route path={`/womens`} element={<WomensPage />} />
            <Route path={`/collections`} element={<CollectionsPage />} />

            <Route path={`/my-account`} element={<MyAccount />}>
              <Route path={`/my-account`} element={<Dashboard />} />
              <Route path={`/my-account/orders`} element={<Orders />} />
              <Route path={`/my-account/order-details/:orderId?`} element={<OrderDetails />} />
              <Route path={`/my-account/profile`} element={<Profile />} />
              <Route path={`/my-account/addresses`} element={<Addresses />} />
              <Route path={`/my-account/change-password`} element={<ChangePassword />} />
            </Route>

            <Route path={`/track-order`} element={<TrackOrder />} />
            <Route path={`/track-order-details`} element={<TrackOrderDetails />} />
            <Route path={`/about-us`} element={<AboutUs />} />
            <Route path={`/return-policy`} element={<ReturnPolicy />} />
            <Route path={`/terms-and-conditions`} element={<TermsAndConditions />} />
            <Route path={`/privacy-policy`} element={<PrivacyPolicy />} />
            <Route path={`/shipping-policy`} element={<ShippingPolicy />} />
            <Route path={`/sustainability`} element={<Sustainability />} />
          </Route>
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}
